import { AUTH_TOKEN } from '../../../constants'

// Meta (Facebook) Pixel ID — "Laiten Web" dataset
const PIXEL_ID = '1474492527301887'

const isLoggedIn = () => {
  try {
    return Boolean(localStorage.getItem(AUTH_TOKEN))
  } catch (e) {
    return false
  }
}

// Inject the Meta Pixel base code (the standard fbq snippet). Runs at most once.
const loadPixelBase = () => {
  if (window.fbq) return
  const n = window.fbq = function () {
    if (n.callMethod) {
      n.callMethod.apply(n, arguments)
    } else {
      n.queue.push(arguments)
    }
  }
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(t, s)
}

// Bootstrap the pixel: load the base code and fire the initial PageView.
// Only for non-authenticated visitors (prospects) — we don't track app users.
export const initMetaPixel = () => {
  if (typeof window === 'undefined') return
  if (isLoggedIn()) return
  const alreadyInit = Boolean(window.fbq)
  loadPixelBase()
  if (!alreadyInit) {
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }
}

// Track a standard Meta event (Lead, Contact, Schedule, ViewContent, ...).
export const trackPixel = (event, props = {}) => {
  if (typeof window === 'undefined') return
  if (isLoggedIn()) return
  if (typeof window.fbq !== 'function') return
  window.fbq('track', event, props)
}

// Track a custom (non-standard) Meta event.
export const trackPixelCustom = (event, props = {}) => {
  if (typeof window === 'undefined') return
  if (isLoggedIn()) return
  if (typeof window.fbq !== 'function') return
  window.fbq('trackCustom', event, props)
}

// Convenience wrappers for the standard events we care about.
export const trackPixelPageView = () => trackPixel('PageView')
export const trackPixelViewContent = (props = {}) => trackPixel('ViewContent', props)
export const trackPixelLead = (props = {}) => trackPixel('Lead', props)
export const trackPixelContact = (props = {}) => trackPixel('Contact', props)
export const trackPixelSchedule = (props = {}) => trackPixel('Schedule', props)
